import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'インプラント治療は痛いですか？',
      answer: '手術中は局所麻酔を使用するため、痛みはほとんど感じません。術後は多少の腫れや痛みが出ることがありますが、処方される痛み止めで十分コントロールできます。当院では痛みの少ない治療を心がけており、フラップレスインプラントなど負担の少ない術式も採用しています。'
    },
    {
      question: '治療期間はどのくらいかかりますか？',
      answer: '1Dayインプラント（オールオン4）の場合、抜歯から仮歯の装着まで1日で完了します。最終的な人工歯への交換は、手術後2〜6ヶ月後に行います。従来のインプラント治療と比べて、大幅に治療期間を短縮できます。'
    },
    {
      question: 'インプラント治療の費用はどのくらいですか？',
      answer: 'インプラント治療は自由診療のため、保険適用外となります。治療内容により異なりますが、1本あたり40〜50万円程度、オールオン4の場合は片顎で200〜300万円程度が目安となります。詳しくは無料カウンセリングでご説明いたします。'
    },
    {
      question: 'インプラントはどのくらい持ちますか？',
      answer: '適切なメンテナンスを行えば、10年以上使用できることが多いです。当院では10年保証を設けており、インプラント本体に関する不具合が原因での再手術や代替治療が必要になった場合、10年以内であれば追加費用は一切発生しません。'
    },
    {
      question: '高齢でもインプラント治療は可能ですか？',
      answer: '年齢制限はありません。全身状態が良好であれば、高齢の方でもインプラント治療は可能です。ただし、糖尿病や心疾患などの持病がある場合は、事前に内科での適切なコントロールが必要になることがあります。まずは無料カウンセリングでご相談ください。'
    },
    {
      question: '骨が少なくてもインプラントはできますか？',
      answer: 'オールオン4やオールオン6という治療法では、骨の質が薄い方でも骨移植を行う必要がないことが多いです。最適な骨質の箇所を選定してインプラントを埋め込むため、従来の方法では難しかった方でも治療が可能になっています。'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
            よくあるご質問
          </h2>
          <p className="text-lg text-teal-600 font-medium">FAQ</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start flex-1">
                  <span className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold mr-4 mt-1">
                    Q
                  </span>
                  <span className="text-lg font-bold text-gray-900 flex-1">{faq.question}</span>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 pt-2">
                  <div className="flex items-start">
                    <span className="flex-shrink-0 w-8 h-8 bg-gray-200 text-gray-700 rounded-full flex items-center justify-center font-bold mr-4">
                      A
                    </span>
                    <p className="text-gray-700 leading-relaxed flex-1">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
